import { trackLink } from "../../../../../../services/analytics";
import getSingleItemProductString from "../../../../analytics/reducer/eventHandlers/getSingleItemProductString";
import { NOTIFY_ME_ACTION } from "../constants";
import {
  ADOBE_SAVED_ITEM_ACTION_KEY,
  ADOBE_PRODUCTS_KEY,
  ADOBE_NOTIFY_ME_EVENT_KEY
} from "../../../../../../services/analytics/constants";

export const updateBackInStockVariants = (
  state,
  { payload: { variantId, isOptedIn } }
) => {
  if (!isOptedIn) {
    const newState = {
      ...state,
      trackLink: {
        products: getSingleItemProductString({
          variantId
        }),
        savedItemAction: NOTIFY_ME_ACTION,
        events: [ADOBE_NOTIFY_ME_EVENT_KEY],
        vars: [ADOBE_SAVED_ITEM_ACTION_KEY, ADOBE_PRODUCTS_KEY]
      }
    };
    trackLink({ state: newState });

    return newState;
  }

  return state;
};
